<template>
 <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex left xs12 sm8 md8 text-xs-center>
            <v-card class="elevation-12">
              <v-toolbar color="red" dark>
                <v-toolbar-title>Project Supervisor</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form v-if="supervisor.length == 0">
                  <v-container grid-list-xl>
                    <v-layout>
                      <v-flex xs12 sm6 md6 text-xs-center>
                        <v-text-field clearable v-model="title" :counter="50" label="Job Title" :error-messages="errors.collect('title')" v-validate="'required|alpha_spaces|max:50|min:1'" data-vv-name="title"required append-icon="fa fa-briefcase" color="black">
                        </v-text-field>
                        <v-text-field clearable v-model="name_en" :counter="50" label="Full Name" :error-messages="errors.collect('name_en')" v-validate="{required: true, min: 10, max: 50, regex: /^\s?\w+(?:\s+\w+\s?){2,4}$/}" data-vv-name="name_en" data-vv-as="name in English" required append-icon="fa fa-user-circle" color="black">
                        </v-text-field>
                        <v-text-field clearable v-model="name_ar" :counter="50" label="الاسم بالكامل" :error-messages="errors.collect('name_ar')" v-validate="{required: true, min: 10, max: 50, regex: /^\s?[\u0621-\u064A0-9]+(?:\s+[\u0621-\u064A0-9]+\s?){2,4}$/}" data-vv-name="name_ar" data-vv-as="name in arabic" required append-icon="fa fa-user-circle" color="black">
                        </v-text-field>
                        <v-text-field v-model="email" clearable :counter="50" label="E-mail Address" :error-messages="errors.collect('email')" clearable  v-validate="'required|email|max:50'" data-vv-name="email" append-icon="fa fa-at" required color="black">
                        </v-text-field>
                        <v-select :items="genders"  clearable  v-model="gender" label="Gender" append-icon="fa fa-male" :error-messages="errors.collect('gender')" v-validate="'required|in:male,female'" data-vv-name="gender" item-text="text"  item-value="value" required color="black">
                        </v-select>
                      </v-flex>

                      <v-flex xs12 sm6 md6 text-xs-center>

                        <v-text-field v-model="phone" clearable  append-icon="fa fa-phone" :counter="11" label="Phone Number" :error-messages="errors.collect('phone')"  v-validate="'digits:11'" data-vv-name="phone" color="black">
                        </v-text-field>

                        <v-text-field clearable v-model="linkedin" :counter="250" label="LinkedIn profile link" :error-messages="errors.collect('linkedin')" v-validate="'required|max:250'" data-vv-name="linkedin" data-vv-as="LinkedIn profile link" append-icon="fa fa-linkedin" required color="black">
                        </v-text-field>

                        <v-text-field multi-line clearable v-model="technical_interests" :counter="250" label="Technical areas of interest" :error-messages="errors.collect('technical_interests')" v-validate="'required|min:10|max:250'" data-vv-name="technical_interests" data-vv-as="Technical areas of interest" append-icon="fa fa-brain" required color="black">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions class="text-xs-center">
                <v-btn color="primary" left @click.prevent="rollBack" >Previous</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click.prevent="addMember" right :disabled="!! (errors.any() || !isDisabled)" default>Add Supervisor</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" v-if="supervisor.length == 1" right @click.prevent="proceed">Next</v-btn>
              </v-card-actions>
              <v-list two-line subheader>
                <v-subheader inset>
                  Supervisor Details
                  <v-spacer></v-spacer>
                  <v-icon>fa fa-users</v-icon>
                </v-subheader>
                <v-list-tile avatar v-for="(supervisor,index) in supervisor" :key="supervisor.name">
                  <v-list-tile-avatar>
                    <v-icon> fa fa-{{ supervisor.gender }}</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{supervisor.title}} {{ supervisor.name_en }} &mdash; {{supervisor.name_ar}}</v-list-tile-title>
                    <v-list-tile-sub-title>
                      <v-icon>email</v-icon> {{supervisor.email}} &mdash; <v-icon>phone</v-icon>{{supervisor.phone}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn icon ripple  @click.prevent="editMember(index)">
                      <v-icon color="grey lighten-1">fa fa-edit</v-icon>
                    </v-btn>
                    <v-btn icon ripple  @click.prevent="removeMember(index)">
                      <v-icon color="grey lighten-1">fa fa-trash</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider inset></v-divider>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>  
</template>
<script>
    export default {
        props : ['user','items','cities'],
        data(){
            return {
                genders : [{text : 'Male' , value:'male'} , {text : 'Female' , value : 'female'}],
                email : '',
                phone : '',
                name_en : '',
                name_ar : '',
                title : '',
                accommodation : false,
                gender : '',
                technical_interests: '',
                linkedin: '',
                supervisor : [],
                country :{
                  name_en : null,
                  has_accommodation : false
                },
                accommodationItem :null,
            }
        },
        created(){
          if (this.user.data.city_id != '') {
            this.country =  this.cities.find(city => city.id == this.user.data.city_id);            
          }
          this.accommodationItem = this.items.find(item => item.name == 'Accommodation');
        },
        computed : {
            isDisabled (){                
              return !! (this.email && this.name_en && this.gender && this.technical_interests && this.linkedin);
            }
        },
        methods : {
            addMember(){          
                let phonePrefix = this.phone.substring(0, 3);
                let memberExists = this.user.data.members.filter(member => member.phone == this.phone || member.email == this.email);
                if (memberExists.length) {
                  this.$noty.error('Supervisor Phone number & E-mail can\'t be the same as member details.');
                  return;
                }
                this.supervisor.push({
                  'phone': this.phone,
                  'email': this.email,
                  'name_en': this.name_en,
                  'gender': this.gender,
                  'name_ar': this.name_ar,
                  'title' : this.title,
                  'linkedin': this.linkedin,
                  'technical_interests': this.technical_interests
                });
                this.phone = '';
                this.email = '';
                this.name_en = '';
                this.name_ar = '';
                this.linkedin = '';
                this.technical_interests = '';
                this.$validator.reset();
                this.errors.clear();
            },
            removeMember(index){
              this.supervisor.splice(index, 1);
            },
            editMember(index) {
              let supervisor = this.supervisor[index];
              this.phone = supervisor.phone;
              this.email = supervisor.email;
              this.name_en = supervisor.name_en;
              this.name_ar = supervisor.name_ar;
              this.gender = supervisor.gender;
              this.linkedin = supervisor.linkedin;
              this.technical_interests = supervisor.technical_interests;
              this.title = supervisor.title;
              this.removeMember(index)
            },
            rollBack(){
               this.$emit('rollback',this.user)
            },
            proceed (){
              this.user.data.supervisor = this.supervisor;
              this.$emit('completed',this.user);
            }
        }

    };
</script>



// WEBPACK FOOTER //
// src/components/Registeration/Supervisors.vue